"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var context_1 = require("../context");
var useLayout_1 = require("../hooks/useLayout");
exports.Layout = function (_a) {
    var children = _a.children, required = _a.required, label = _a.label, addonBefore = _a.addonBefore, addonAfter = _a.addonAfter, description = _a.description, props = __rest(_a, ["children", "required", "label", "addonBefore", "addonAfter", "description"]);
    var layout = useLayout_1.useLayout(__assign(__assign({}, props), { isLayout: true }));
    return react_1.default.createElement(context_1.LayoutContext.Provider, { value: layout }, children(__assign(__assign({}, layout), { label: label,
        required: required,
        addonBefore: addonBefore,
        addonAfter: addonAfter,
        description: description })));
};
exports.LayoutItem = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var layoutItem = useLayout_1.useLayoutItem(props);
    return children(layoutItem);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react/lib/components/Layout.js
// module id = 5767
// module chunks = 0